import MojitoPresentation from 'mojito/presentation';
import PrebuiltBetView from 'modules/prebuilt-bets/prebuilt-bet/view/index.js';
import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import { useMemo } from 'react';

const { getSeparatorTranslationKey } = MojitoPresentation.Utils.ParticipantSeparator;
const AnalyticsTypes = MojitoServices.Analytics.types;
const {
    FlexPane,
    Image,
    Text,
    DateTime,
    NeutralVenueIndicator,
    ParticipantIconsInline,
    scoreboardUtils: { sortParticipants },
} = MojitoPresentation.Components;
const { PREBUILT_MATCH_ACCA, PREBUILT_MATCH_ACCA_BOOST } = AnalyticsTypes.SELECTION_TYPE;
const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;
const AnalyticsContextBuilder = MojitoCore.Presentation.AnalyticsContext.ContextBuilder;

const PrebuiltBetBuilder = props => {
    const {
        mojitoTools: { config, stringResolver },
        event,
        market,
        promotionText,
        boostedMarket,
        onEventClick,
    } = props;
    const hasPromotionText = Boolean(promotionText);

    const participants = useMemo(
        () => sortParticipants(event?.participants, event?.homeAway),
        [event?.participants, event?.homeAway]
    );

    const analyticsContext = useMemo(() => {
        const path = boostedMarket ? PREBUILT_MATCH_ACCA_BOOST : PREBUILT_MATCH_ACCA;
        return new AnalyticsContextBuilder().withAnalyticsPath(path).build();
    }, [boostedMarket]);

    return (
        <AnalyticsContextExtender value={analyticsContext} pathSeparator={'_'} pathReverse={true}>
            <PrebuiltBetView
                config={config.view}
                market={market}
                boostedMarket={boostedMarket}
                event={event}
                onEventClick={onEventClick}
                class={'ta-PrebuiltBetBuilder'}
            >
                {config.view.showCardHeader && (
                    <FlexPane class="ta-PrebuiltBetHeader" config={config.headerContainer}>
                        <Image config={config.matchAccaIcon} />
                        <FlexPane config={config.headerTextContainer}>
                            {hasPromotionText && (
                                <Text config={config.promotionText}>{promotionText}</Text>
                            )}
                            <ParticipantIconsInline
                                participants={participants}
                                sportId={event?.sportId}
                                separator={stringResolver.resolveString(
                                    getSeparatorTranslationKey(event?.homeAway)
                                )}
                                config={config.participantsIconInline}
                            />
                            <FlexPane config={config.timeAndTypeContainer}>
                                <Text config={config.startTime}>
                                    <DateTime
                                        config={config.startTimeFormat}
                                        dateTime={event?.startTime}
                                    />
                                </Text>
                                <Text config={config.typeName}>{` - ${event?.typeName}`}</Text>
                            </FlexPane>
                        </FlexPane>
                        {event?.neutral && (
                            <NeutralVenueIndicator config={config.neutralVenueIndicator} />
                        )}
                    </FlexPane>
                )}
            </PrebuiltBetView>
        </AnalyticsContextExtender>
    );
};

export default PrebuiltBetBuilder;
